angular.module('satv.playlist.pitch')

    .controller('PitchModalFormCtrl', function ($scope, Pitch, $filter, SelectCompanyModal, SelectUserModal, PitchEmailer, Channel, Auth, growl) {
        'use strict';

        $scope.Auth = Auth;
//
// $scope.$watch('pitch',
//     function(newVal, oldVal){
//         console.log('pitch  new: ');
//         console.log(newVal);
//         console.log('pitch  old: ');
//         console.log(oldVal);
// });

        if (!$scope.pitch) {
            $scope.pitch = {
                max_auditions: 100,
                max_downloads: 100,
                playlist: null,
                show_user: true,
                type: null,
                status: "1",
                expiry_date: null,
                expiry_date_max: null,
                expiry_date_min: new Date()
            };
            Auth.acl('pitch_unlimited_time')
                .then(function(isGranted) {
                    var now = new Date();
                    if (isGranted) {
                        now.setMonth(now.getMonth() + 6);
                        now.setDate(now.getDate() - 1);
                        $scope.pitch.expiry_date = now;
                        $scope.pitch.expiry_date_max = "";
                        $scope.pitch.expiry_date = new Date(now.getTime());
                    } else {
                        now.setMonth(now.getMonth() + 3);
                        now.setDate(now.getDate() - 1);
                        $scope.pitch.expiry_date_max = new Date(now.getTime());
                        $scope.pitch.expiry_date =  new Date(now.getTime());
                    }
                });
        } else {
            //copy from the parent scope, as we don't want to modify the pitch in the
            //parent scope.
            $scope.pitch = angular.copy($scope.pitch);
            //convert field types for form
            $scope.pitch.type = String($scope.pitch.type);
            $scope.pitch.expiry_date = new Date($scope.pitch.expiry_date);
            $scope.pitch.status = String($scope.pitch.status);
        }

        Channel.query(function(r) {
            $scope.channels = r;
        });

        function isObject(value) {
            return value !== null && typeof value === 'object' && Array.isArray(value) === false;
        }

        $scope.submit = function(playlist, pitch, sendEmail) {
            Pitch.save({
                hash: pitch.hash,
                playlist: playlist.id,
                recipients: pitch.recipients ? pitch.recipients.map(function(user) {
                    return user.id;
                }) : null,
                maxAuditions: pitch.max_auditions,
                maxDownloads: pitch.max_downloads,
                expiryDate: pitch.expiry_date,
                showUser: pitch.show_user,
                type: pitch.type,
                company: pitch.company ? pitch.company.id : null,
                channel: isObject(pitch.channel) ? pitch.channel.id : pitch.channel,
                status: pitch.status
            }, function(resp) {
                $scope.$close(true);
                if (sendEmail) {
                    PitchEmailer.open(resp.data || pitch);
                }
            }, function(resp) {
                if (resp.data) {
                    $scope.errors = resp.data.errors;
                }
            });
        };

        $scope.selectCompany = function() {
            SelectCompanyModal.open({
                success: function(r) {
                    var company = r[1];
                    $scope.pitch.company = {
                        id: company.id,
                        name: company.name
                    };
                }
            }, {
                terms: {
                    textQuery: $scope.pitch.company ? $scope.pitch.company.name : null
                }
            });
        };

        $scope.selectUsers = function() {
            SelectUserModal.open({
                success: function(r) {
                    var users = r[1];
                    $scope.pitch.recipients = users;

                    //if a company is known, select the first one
                    if (users[0].company) {
                        $scope.pitch.company = users[0].company;
                    }

                    function validateUsers(users) {
                        for (var i=0;i<users.length;i++) {
                            if (users[i].flag === 1) {
                                return false;
                            }
                        }
                        return true;
                    }

                    function validateUserCompanies(users) {
                        for (var i=0;i<users.length;i++) {
                            for (var j=0;j<users.length;j++) {
                                if (users[i].company &&
                                    users[j].company &&
                                    users[i].company !== users[j].company) {
                                    return false;
                                }
                            }
                        }
                        return true;
                    }

                    //check if users of different companies have been selected
                    $scope.hasMultipleCompanies = !validateUserCompanies(users);
                    $scope.hasInvalidUsers = !validateUsers(users);
                }
            }, {
                multiple: true,
                selected: angular.copy($scope.pitch.recipients),
                isSelectable: function(model) {
                    //users that require attention cannot be selected
                    return model.flag !== 1;
                },
                config: {
                    userFormModal: {
                        defaultRoles: ['ROLE_CONTACT', 'ROLE_SYNCH']
                    }
                }
            });
        };
    })
;



// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistpitchclientbundle/Resources/js/angular/controllers/PitchModalFormCtrl.js